import Departments from 'models/departments';
import { Category } from '../../../models/category';
import { overrideCategory } from './categoryHelpers';
import { isEmptyGeneralCategoryNewInSale } from './conditionsHelpers';
import { FormattedSeason } from '../../../components/Filters/CheckboxFilter/SeasonsFilter/useFormattedSeasons';

type ProductListDescriptionFactory = (
  urlQueryParams: Record<string, string | string[]>,
  departmentInternal: string,
  currentSeason: FormattedSeason,
  brandName?: string,
  selectedCategory?: Category,
) => string;

export const productListDescriptionFactory: ProductListDescriptionFactory = (
  urlQueryParams,
  departmentInternal,
  currentSeason,
  brandName,
  selectedCategory,
) => {
  const brandWithSpace = brandName ? `${brandName} ` : '';
  const realDepartmentInternal =
    departmentInternal && departmentInternal !== '' ? departmentInternal : Departments.getWomenInternalName();
  const department = Departments.getName(realDepartmentInternal);

  if (isEmptyGeneralCategoryNewInSale({ selectedCategory, urlQueryParams })) {
    if (brandName && !selectedCategory) {
      return `Shop the ${
        currentSeason.displayName
      } collection in ${brandWithSpace}Luxury Fashion for ${department.toLowerCase()}. EXPRESS international shipping!`;
    }

    return `Shop the latest selection from the best global designer brands at italist and save up to 40% Express shipping on over 1000 brands for ${department.toLowerCase()}`;
  }

  const overriddenCategory = overrideCategory(realDepartmentInternal, selectedCategory.name);
  return `Shop the ${
    currentSeason.displayName
  } collection in ${brandWithSpace}${overriddenCategory.toLowerCase()} for ${department.toLowerCase()}. EXPRESS international shipping!`;
};
